export const isHiddenClassname = 'toHideIfIframe'
export const iframeClassname = 'iframe'
export const showIframeClassname = 'toShowIfIframe'
